module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<div>\n<%\nvar cols = 6;\nvar i,j,k, mailingList, segment, cntSegmentAssignedToMailings;\nfor (i=0; i<((resourceData || {}).data || []).length; i++) {\nmailingList = resourceData.data[i];\n%>\n<button class=\"addSegment\" type=\"button\" data-mailing-list-id=\"<%= mailingList.attributes.mailingListID %>\" data-additional-data-component-id=\"<%= mailingList.attributes.additionalDataComponentID %>\"><i class=\"fi fi-segment\"></i> Neues Segment</button>\n<table cellspacing=\"1\">\n<thead>\n<tr>\n<th colspan=\"<%= cols %>\">\nMailingliste \"<%= mailingList.attributes.name %>\"\n</th>\n</tr>\n</thead>\n<tbody data-mailing-list-id=\"<%= mailingList.attributes.mailingListID %>\" data-additional-data-component-id=\"<%= mailingList.attributes.additionalDataComponentID %>\">\n<tr>\n<td><strong>Segmentname</strong></td>\n<td align=\"center\"><strong>Empfänger</strong></td>\n<td align=\"center\"><strong>Verwendet</strong></td>\n<td colspan=\"3\" align=\"right\"><strong>Aktion</strong></td>\n</tr>\n<%\nvar segmentIndexOrder = [];\nfor (j=0; j<((mailingList || {}).children.nl_segments.data || []).length; j++) {\nsegment = mailingList.children.nl_segments.data[j].attributes;\nif (segment.matchingType === 'all') {\nsegmentIndexOrder.unshift(j);\n} else {\nsegmentIndexOrder.push(j);\n}\n}\nfor (k=0; k<segmentIndexOrder.length; k++) {\nj = segmentIndexOrder[k];\nsegment = mailingList.children.nl_segments.data[j].attributes;\ncntSegmentAssignedToMailings = utils.collectionSize((mailingList.children.nl_segments.data[j].children.nl_mailings_segments || {}).data || []);\n%>\n<tr data-segment-id=\"<%= segment.segmentID %>\">\n<% if (segment.matchingType === 'all') { %>\n<td>\n<i class=\"fi fi-segment\"></i>\n<div class=\"name\">\n<div class=\"title\"><%= segment.name %></div>\n<div class=\"lastSegmentUpdateTS\"><%= segment.subscriberCountTimeStamp ? 'Zuletzt aktualisiert am: ' + utils.moment(segment.subscriberCountTimeStamp).format('DD.MM.YYYY HH:mm:ss') : '' %></div>\n</div>\n</td>\n<td align=\"center\"><%= segment.subscriberCount %></td>\n<td align=\"center\"><%= cntSegmentAssignedToMailings %></td>\n<td>&nbsp;</td>\n<td class=\"refresh\"><i class=\"fi fi-refresh\"></i></td>\n<td>&nbsp;</td>\n<% } else { %>\n<td>\n<i class=\"fi fi-segment\"></i>\n<div class=\"name\">\n<div class=\"title\"><%= segment.name %></div>\n<div class=\"lastSegmentUpdateTS\"><%= segment.subscriberCountTimeStamp ? 'Zuletzt aktualisiert am: ' + utils.moment(segment.subscriberCountTimeStamp).format('DD.MM.YYYY HH:mm:ss') : '' %></div>\n</div>\n</td>\n<td align=\"center\"><%= segment.subscriberCount %></td>\n<td align=\"center\"><%= cntSegmentAssignedToMailings %></td>\n<% if (cntSegmentAssignedToMailings === 0) { %><td class=\"delete\"><i class=\"fi fi-times\"></i></td><% } else { %><td>&nbsp;</td><% } %>\n<td class=\"refresh\"><i class=\"fi fi-refresh\"></i></td>\n<td class=\"edit\"><i class=\"fi fi-edit\"></i></td>\n<% } %>\n</tr>\n<%\n}\n%>\t\t</tbody>\n<tfoot>\n<tr>\n<td colspan=\"<%= cols %>\" align=\"right\">&nbsp;</td>\n</tr>\n</tfoot>\n</table>\n<br>\n<%\n}\n%>\n</div>"
  , __filename = "components/templates/newsletter/segments/list.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div>\n")
    ; __line = 2
    ; 
var cols = 6;
var i,j,k, mailingList, segment, cntSegmentAssignedToMailings;
for (i=0; i<((resourceData || {}).data || []).length; i++) {
mailingList = resourceData.data[i];

    ; __line = 7
    ; __append("\n<button class=\"addSegment\" type=\"button\" data-mailing-list-id=\"")
    ; __line = 8
    ; __append(escapeFn( mailingList.attributes.mailingListID ))
    ; __append("\" data-additional-data-component-id=\"")
    ; __append(escapeFn( mailingList.attributes.additionalDataComponentID ))
    ; __append("\"><i class=\"fi fi-segment\"></i> Neues Segment</button>\n<table cellspacing=\"1\">\n<thead>\n<tr>\n<th colspan=\"")
    ; __line = 12
    ; __append(escapeFn( cols ))
    ; __append("\">\nMailingliste \"")
    ; __line = 13
    ; __append(escapeFn( mailingList.attributes.name ))
    ; __append("\"\n</th>\n</tr>\n</thead>\n<tbody data-mailing-list-id=\"")
    ; __line = 17
    ; __append(escapeFn( mailingList.attributes.mailingListID ))
    ; __append("\" data-additional-data-component-id=\"")
    ; __append(escapeFn( mailingList.attributes.additionalDataComponentID ))
    ; __append("\">\n<tr>\n<td><strong>Segmentname</strong></td>\n<td align=\"center\"><strong>Empfänger</strong></td>\n<td align=\"center\"><strong>Verwendet</strong></td>\n<td colspan=\"3\" align=\"right\"><strong>Aktion</strong></td>\n</tr>\n")
    ; __line = 24
    ; 
var segmentIndexOrder = [];
for (j=0; j<((mailingList || {}).children.nl_segments.data || []).length; j++) {
segment = mailingList.children.nl_segments.data[j].attributes;
if (segment.matchingType === 'all') {
segmentIndexOrder.unshift(j);
} else {
segmentIndexOrder.push(j);
}
}
for (k=0; k<segmentIndexOrder.length; k++) {
j = segmentIndexOrder[k];
segment = mailingList.children.nl_segments.data[j].attributes;
cntSegmentAssignedToMailings = utils.collectionSize((mailingList.children.nl_segments.data[j].children.nl_mailings_segments || {}).data || []);

    ; __line = 38
    ; __append("\n<tr data-segment-id=\"")
    ; __line = 39
    ; __append(escapeFn( segment.segmentID ))
    ; __append("\">\n")
    ; __line = 40
    ;  if (segment.matchingType === 'all') { 
    ; __append("\n<td>\n<i class=\"fi fi-segment\"></i>\n<div class=\"name\">\n<div class=\"title\">")
    ; __line = 44
    ; __append(escapeFn( segment.name ))
    ; __append("</div>\n<div class=\"lastSegmentUpdateTS\">")
    ; __line = 45
    ; __append(escapeFn( segment.subscriberCountTimeStamp ? 'Zuletzt aktualisiert am: ' + utils.moment(segment.subscriberCountTimeStamp).format('DD.MM.YYYY HH:mm:ss') : '' ))
    ; __append("</div>\n</div>\n</td>\n<td align=\"center\">")
    ; __line = 48
    ; __append(escapeFn( segment.subscriberCount ))
    ; __append("</td>\n<td align=\"center\">")
    ; __line = 49
    ; __append(escapeFn( cntSegmentAssignedToMailings ))
    ; __append("</td>\n<td>&nbsp;</td>\n<td class=\"refresh\"><i class=\"fi fi-refresh\"></i></td>\n<td>&nbsp;</td>\n")
    ; __line = 53
    ;  } else { 
    ; __append("\n<td>\n<i class=\"fi fi-segment\"></i>\n<div class=\"name\">\n<div class=\"title\">")
    ; __line = 57
    ; __append(escapeFn( segment.name ))
    ; __append("</div>\n<div class=\"lastSegmentUpdateTS\">")
    ; __line = 58
    ; __append(escapeFn( segment.subscriberCountTimeStamp ? 'Zuletzt aktualisiert am: ' + utils.moment(segment.subscriberCountTimeStamp).format('DD.MM.YYYY HH:mm:ss') : '' ))
    ; __append("</div>\n</div>\n</td>\n<td align=\"center\">")
    ; __line = 61
    ; __append(escapeFn( segment.subscriberCount ))
    ; __append("</td>\n<td align=\"center\">")
    ; __line = 62
    ; __append(escapeFn( cntSegmentAssignedToMailings ))
    ; __append("</td>\n")
    ; __line = 63
    ;  if (cntSegmentAssignedToMailings === 0) { 
    ; __append("<td class=\"delete\"><i class=\"fi fi-times\"></i></td>")
    ;  } else { 
    ; __append("<td>&nbsp;</td>")
    ;  } 
    ; __append("\n<td class=\"refresh\"><i class=\"fi fi-refresh\"></i></td>\n<td class=\"edit\"><i class=\"fi fi-edit\"></i></td>\n")
    ; __line = 66
    ;  } 
    ; __append("\n</tr>\n")
    ; __line = 68
    ; 
}

    ; __line = 70
    ; __append("		</tbody>\n<tfoot>\n<tr>\n<td colspan=\"")
    ; __line = 73
    ; __append(escapeFn( cols ))
    ; __append("\" align=\"right\">&nbsp;</td>\n</tr>\n</tfoot>\n</table>\n<br>\n")
    ; __line = 78
    ; 
}

    ; __line = 80
    ; __append("\n</div>")
    ; __line = 81
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/newsletter/segments/list.ejs

}